import React from 'react'
import logo from '../images/bubble-logo-2.svg'

export const Loading = () => {
  return (
    <div className="container-md py-64 text-center">
      <img src={logo} alt="" />
    </div>
  )
}
